import { OpenAPI as ListingsOpenAPI } from './api/listings-client/core/OpenAPI';
import { OpenAPI as AccountsOpenAPI } from './api/accounts-client/core/OpenAPI';
import { OpenAPI as MediaOpenAPI } from './api/media-client/core/OpenAPI';
import { OpenAPI as MessagesOpenAPI } from './api/messages-client/core/OpenAPI';
import { OpenAPI as SearchOpenAPI } from './api/search-client/core/OpenAPI';

export const configureApi = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';
  console.log("BASE_URL ", BASE_URL);
  
  [ListingsOpenAPI, AccountsOpenAPI, MediaOpenAPI, MessagesOpenAPI, SearchOpenAPI].forEach(api => {
    api.BASE = BASE_URL;
    api.WITH_CREDENTIALS = true;
    // Add any other common configuration here
    // For example:
    // api.HEADERS = { ... }
    // api.TOKEN = () => localStorage.getItem('auth_token');
  });
};